import { createId } from "../../app/runtimeContext";
import type { CyanIntelligenceRepository } from "./repositories";
import type { Conversation, ConversationMessage, CyanIntent } from "./types";

export class ConversationManager {
  constructor(private readonly repository: CyanIntelligenceRepository) {}

  async createConversation(input: {
    organizationId: string;
    productId?: string;
    title: string;
    context?: Record<string, unknown>;
  }): Promise<Conversation> {
    const now = new Date().toISOString();
    const conversation: Conversation = {
      id: createId("conversation"),
      organizationId: input.organizationId,
      productId: input.productId,
      title: input.title,
      context: input.context ?? {},
      messages: [],
      createdAt: now,
      updatedAt: now,
    };
    await this.repository.saveConversation(conversation);
    return conversation;
  }

  async addMessage(
    conversation: Conversation,
    input: Omit<ConversationMessage, "id" | "createdAt"> & {
      intent?: CyanIntent;
    },
  ): Promise<Conversation> {
    const message: ConversationMessage = {
      ...input,
      id: createId("message"),
      intent: input.intent ?? "unknown",
      createdAt: new Date().toISOString(),
    };
    const updated = {
      ...conversation,
      messages: [...conversation.messages, message],
      updatedAt: message.createdAt,
    };
    await this.repository.saveConversation(updated);
    return updated;
  }
}
